module.exports = __webpack_public_path__ + "img/fullD.cc7289f5.png";